import { Component, OnInit, Output, Input, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { LoginService } from '../../services/login/login.service';
import { Router } from '@angular/router';
import { ConfigParamsService } from '../../services/configParameters/config-params.service';
declare var $; // jquery

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnChanges {
  @Output() navToggle = new EventEmitter<Boolean>();
  private menuIsOpen: Boolean = false;
  @Output() tornarEndarreraToggle = new EventEmitter<Boolean>();
  @Output() tencarSessio = new EventEmitter<String>();
  @Input() showEndarrera: number = -1;
  @Input() layerTitle: string;

  protected header_title = "Edició GIS";
  constructor(private loginService: LoginService, protected configParamsService: ConfigParamsService, protected router: Router) {

    if (!this.loginService.checkLogin() && this.configParamsService.isPrivateApp()) {
      this.router.navigate(["/privat"]);
    }
  }

  navOpen() {
    this.navToggle.emit(this.menuIsOpen);
    this.menuIsOpen = !this.menuIsOpen;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    console.debug(">>> IdentifyControlComponent: ngOnChanges");
    try {
      if (typeof (changes.showEndarrera) !== "undefined" && typeof (changes.showEndarrera.currentValue) !== "undefined") {
        this.toggleTornarEndarreraChange(changes.showEndarrera.currentValue);
      }
      if (typeof (changes.layerTitle) !== "undefined" && typeof (changes.layerTitle.currentValue) !== "undefined" && changes.layerTitle.currentValue.length > 0) {
        this.header_title = changes.layerTitle.currentValue;
      }
    }
    catch (e) { console.warn("Ups, hi ha hagut algun problema al ngOnChanges del identify-control.component.ts", e); }
  }

  tornarEndarrera(event) {
    this.toggleTornarEndarrera();
    this.tornarEndarreraToggle.emit(true);
  }

  public tencaSessio() {
    this.loginService.doLogout();
    this.configParamsService.resetEditionLayers();
    this.router.navigate(['/privat']);
  }

  toggleTornarEndarrera() {
    if (this.showEndarrera > 0) {
      this.showEndarrera = -1;
    } else {
      let d = new Date();
      this.showEndarrera = d.getTime();
    }
  }


  toggleTornarEndarreraChange(event) {
    this.showEndarrera = event;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/header/header.component.ts